'use strict';

var isMotionValue = require('../../../../../../../motion-dom/dist/es/value/utils/is-motion-value.cjs');

function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue.isMotionValue(value) && value.add);
}

exports.isWillChangeMotionValue = isWillChangeMotionValue;
//# sourceMappingURL=is.cjs.map
